export const ARTICLE_PARAGRAPH = 'ComponentLyberBlogArticleParagraph'
export const CALL_TO_ACTION = 'ComponentLyberBlogCallToAction'
export const PICTURE = 'ComponentLyberBlogPicture'